// extracted by mini-css-extract-plugin
export default {"fixed":"FixedButtons_fixed__RV+I3","upper":"FixedButtons_upper__biuLO","lower":"FixedButtons_lower__grarO","free":"FixedButtons_free__wg2GK","connect":"FixedButtons_connect__GeBeM"};